import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';

import _FM_SettingsFormComponent from "../components/_FM_settings/_FM_SettingsFormComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_SettingsPage = (props) => {

  const {t} = props;

  useEffect(() => {
    document.title = t('settings') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/settings')
  }, []);

  return (
    <div className="ProfilePage p-component p-my-lg-4 p-mx-lg-auto" style={{maxWidth: '780px'}}>
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/settings"}/>
      <_FM_SettingsFormComponent/>
    </div>
  )
}
export default withTranslation('common')(_FM_SettingsPage);
